const a = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M0 8a1 1 0 0 0 1 1h5.833c.092 0 .167.075.167.167V15a1 1 0 1 0 2 0V9.167C9 9.075 9.075 9 9.167 9H15a1 1 0 1 0 0-2H9.167A.167.167 0 0 1 9 6.833V1a1 1 0 1 0-2 0v5.833A.167.167 0 0 1 6.833 7H1a1 1 0 0 0-1 1"/></svg>';
export {
  a as default
};
